export enum ViewLinkType {
  none = 1,
  listView = 2,
  detailView = 3,
}

export const ViewLinkTypeName = {
  [ViewLinkType.none]: 'None',
  [ViewLinkType.listView]: 'List View',
  [ViewLinkType.detailView]: 'Detail View',
};
